import Head from 'next/head'
import { useRouter } from 'next/router'
import { Trans, useTranslation } from 'next-i18next/pages'
import React from 'react'
import { config } from '@/site.config'
import { getStaticPaths, makeStaticProps } from '@/utils/getStatic'

const TermsOfServicePage = () => {
  const { t } = useTranslation(['common', 'terms-of-service'])
  const router = useRouter()
  const locale =
    typeof router.query.locale === 'string' ? router.query.locale : 'en'

  return (
    <div className="relative overflow-hidden bg-transparent">
      <Head>
        <title>
          {t(`TermsOfService.termsTitle`, { ns: 'terms-of-service' })}
        </title>
        <meta
          name="description"
          content={t(`TermsOfService.description`, { ns: 'terms-of-service' })}
        />
        <meta
          property="og:description"
          content={t(`TermsOfService.description`, { ns: 'terms-of-service' })}
        />
        <meta
          property="og:title"
          content={t(`TermsOfService.termsTitle`, { ns: 'terms-of-service' })}
        />
        <meta
          property="og:url"
          content={`${config.prodDomain}${router.asPath}`}
        />
        <meta property="og:site_name" content={t('title')} />
      </Head>
      <article lang="en" className="relative py-4 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-prose text-lg">
          <h2>
            <span className="mt-2 block text-center text-3xl font-bold leading-8 tracking-tight text-gray-900 dark:text-white sm:text-4xl">
              {t('TermsOfService.termsTitle', { ns: 'terms-of-service' })}
            </span>
          </h2>
        </div>
        <div className="prose prose-lg prose-indigo mx-auto mt-6 dark:text-white">
          <p
            className="rounded-md border border-indigo-200 bg-indigo-50 px-4 py-3 text-sm font-medium text-gray-700 dark:border-indigo-800 dark:bg-indigo-950/40 dark:text-gray-200"
            data-test="terms-language-notice"
            lang={locale}
          >
            {t('TermsOfService.englishLanguageNotice')}
          </p>
          <div className="mt-2">
            <div className="[&_p]:my-5 [&_strong]:text-inherit text-sm text-gray-500 text-left dark:text-gray-300">
              <em>
                {t('TermsOfService.lastUpdated', {
                  ns: 'terms-of-service',
                  val: new Date(2026, 4 - 1, 26),
                  formatParams: {
                    val: { year: 'numeric', month: 'long', day: 'numeric' },
                  },
                })}
              </em>
              <Trans
                i18nKey="TermsOfService.termsContent"
                ns={'terms-of-service'}
              ></Trans>
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-300">
              {t('TermsOfService.attribution', { ns: 'terms-of-service' })}
            </p>
          </div>
        </div>
      </article>
    </div>
  )
}

export default TermsOfServicePage
const getStaticProps = makeStaticProps([
  'common',
  'terms-of-service',
  'articles-listing',
])

export { getStaticPaths, getStaticProps }
